var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard45(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.68,106.69A69.56,69.56,0,0,0,105,156.51a39.84,39.84,0,1,1,60-50.66h12.8a51.27,51.27,0,1,0-75.27,63.07,70.35,70.35,0,0,0-.39,7.3,69.54,69.54,0,1,0,69.54-69.53Zm-.05,126.36a56.83,56.83,0,0,1-56.83-56.83v-.05a56.87,56.87,0,0,1,56.79-56.78h0a56.83,56.83,0,1,1,0,113.66Z",
    fill: "#300b5c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195,173.53l-.24.1h-19V144.79a6.3,6.3,0,1,0-12.37-2.4,6.06,6.06,0,0,0,0,2.4v35.28a6.44,6.44,0,0,0,6.3,6.58H195a6.58,6.58,0,0,0,0-13.12Z",
    fill: "#300b5c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131,69.13a5.69,5.69,0,0,0,5.71-5.69v-20a5.7,5.7,0,0,0-11.4,0v20A5.69,5.69,0,0,0,131,69.13Z",
    fill: "#300b5c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.78,85.45a5.7,5.7,0,0,0,7.89-1.66l14.14-13.91h0a5.59,5.59,0,1,0-8-7.83L172.7,76a5.76,5.76,0,0,0-1.58,1.61A5.7,5.7,0,0,0,172.78,85.45Z",
    fill: "#300b5c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.64,85.27a5.7,5.7,0,0,0,8.06-8.06L74.79,63.3h0a5.69,5.69,0,0,0-8.06,0h0a5.69,5.69,0,0,0,0,8.06Z",
    fill: "#300b5c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.68,126.25a5.7,5.7,0,0,0-5.7-5.7H48A5.7,5.7,0,0,0,48,132H68A5.7,5.7,0,0,0,73.68,126.25Z",
    fill: "#300b5c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.83,168.75a5.71,5.71,0,0,0-8.06-.18L68.21,183.08a5.71,5.71,0,0,0,8.07,8.07l14.55-14.33h0a5.7,5.7,0,0,0,0-8.06Z",
    fill: "#300b5c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard45);
export default __webpack_public_path__ + "static/media/card4_5.6e2d487070638d644d15adcd083bd406.svg";
export { ForwardRef as ReactComponent };